module.exports = {
  primaryColor: `#0a2235`,
  secondaryColor: `#123d5f`,
  linkedin: `https://www.linkedin.com/in/tomdhoward/`,
  twitter: `https://twitter.com/Tom_Howard`,
  github: `https://github.com/th0mashoward`,
  drupal: `https://www.drupal.org/u/thoward216`,
  email: `mailto:tomhoward216@gmail.com`,
};
